import { HTMLProps } from 'react';
import SendIcon from '@mui/icons-material/Send';
import * as Styles from './TransparentButton.styles';

export type TransparentButtonStylesType = {
  isBlueButton?: boolean;
  isRedButton?: boolean;
};

type TransparentButtonType = TransparentButtonStylesType &
  Pick<HTMLProps<HTMLButtonElement>, 'onClick' | 'disabled' | 'style'> &
  Pick<HTMLProps<HTMLLinkElement>, 'href' | 'download'> & {
    type?: 'submit' | 'button';
    icon?: typeof SendIcon;
    children: string | JSX.Element;
    link?: boolean;
  };

export default function TransparentButton({
  children,
  icon: Icon,
  link,
  ...props
}: TransparentButtonType): JSX.Element {
  return (
    <Styles.TransparentButton {...props} as={link ? 'a' : 'button'}>
      {!!Icon && <Icon />}
      {children}
    </Styles.TransparentButton>
  );
}
